import { EuiBasicTableColumn } from "@elastic/eui";
import { COLORS, badgeColors, badgeTextColors } from "Consts";
import LinkToList from "components/Popover/LinkToList";
import Badge from "components/Badge/Badge";
import { ResourcesIcon, ObjectIcon, ProfileIcon } from "components/Icons";

export const TOLERANCE_STATUS_COLOR: any = {
  Low: COLORS.$euiColorDanger,
  Medium: COLORS.$euiColorWarning,
  High: COLORS.$healthy,
};

export const exportColumns = [
  {
    field: "name",
    name: "Name",
  },
  {
    field: "description",
    name: "Description",
  },
  {
    field: "monitoringProfileAssignments",
    name: "Profiles",
    render: (monitoringProfileAssignments: any) => {
      return monitoringProfileAssignments.map((i: any) => i.name).join("; ");
    },
  },
  {
    field: "categoryAssignments",
    name: "Alert Categories",
    render: (categoryAssignments: any) => {
      return categoryAssignments.map((i: any) => i.name).join("; ");
    },
  },
];

export const TABS = [
  {
    disabled: false,
    id: "Tolerance",
    name: "Tolerance",
  },
  {
    disabled: false,
    id: "Rules",
    name: "Rules",
  },
];

export const NOT_SELECTED = "Not selected";
export const NO_DESCRIPTION = "No Description";
export const NO_RECOMMENDATIONS = "No Recommendations";
export const thresholdActions = {
  create: "Create",
  update: "Update",
  revert: "Revert",
  delete: "Delete",
};

export const rulesColumns: Array<EuiBasicTableColumn<any>> = [
  {
    field: "name",
    name: "Name",
    sortable: true,
  },
  {
    field: "alertType",
    name: "Alert Type",
    sortable: true,
    render: (alertType: any) => {
      return alertType || "";
    },
  },
  {
    field: "objects",
    name: "Objects",
    sortable: true,
    className: "no-click",
    width: "8%",
    render: (objects: any) => {
      if (!objects || objects?.length === 0) return "";

      const objectsColumn = [
        {
          field: "name",
          name: "Objects",
        },
      ];

      return (
        <LinkToList
          ButtonTitle={
            <span style={{ display: "flex", alignItems: "center", color: "var(--text)" }}>
              <ObjectIcon fill="var(--violet)" />
              <span style={{ marginLeft: "8px" }}>{objects?.length}</span>
            </span>
          }
          Columns={objectsColumn}
          Items={objects}
          PopOverMaxWidth={300}
          Copy={false}
          showHeaders={true}
          enableSearch={false}
        />
      );
    },
  },
  {
    field: "resources",
    name: "Scope",
    sortable: true,
    className: "no-click",
    width: "8%",
    render: (resources, row) => {
      const data = resources?.length > 0 ? resources : row.profiles;

      const dataColumn = [
        {
          field: "name",
          name: resources?.length > 0 ? "Resources" : "Profiles",
        },
      ];

      return (
        <LinkToList
          ButtonTitle={
            <span style={{ display: "flex", alignItems: "center", color: "var(--text)" }}>
              {resources?.length > 0 ? (
                <ResourcesIcon fill="#FF7E62" />
              ) : (
                <ProfileIcon size="18px" />
              )}
              <span style={{ marginLeft: "8px" }}>{data?.length}</span>
            </span>
          }
          Columns={dataColumn}
          Items={data}
          PopOverMaxWidth={300}
          Copy={false}
          showHeaders={true}
          enableSearch={false}
        />
      );
    },
  },
  {
    field: "ignoreAlert",
    name: "Ignore Alert",
    sortable: true,
    render: (ignoreAlert: any) => {
      return (
        <Badge
          text={ignoreAlert ? "True" : "False"}
          color={ignoreAlert ? badgeColors.$red : badgeColors.$green}
          style={{
            color: ignoreAlert ? badgeTextColors.$red : badgeTextColors.$green,
          }}
        />
      );
    },
  },
  {
    field: "isEnabled",
    name: "Status",
    sortable: true,
    render: (isEnabled: any) => {
      return (
        <Badge
          text={isEnabled ? "Enabled" : "Disabled"}
          color={isEnabled ? badgeColors.$green : badgeColors.$red}
          style={{
            color: isEnabled ? badgeTextColors.$green : badgeTextColors.$red,
          }}
        />
      );
    },
  },
];
